import { default as clubMapIE } from "./ie/clubmap";
import { default as clubMapDefault } from "./default/clubmap";

const ie = typeof window !== "undefined" && !!window.MSInputMethodContext && !!document.documentMode;
const ClubMap = ie ? clubMapIE : clubMapDefault;

export default ClubMap;
